/**
 * Avalara © 2017
 * file: engines/opus_ui/src/Services.js
 */

import React, { Component } from 'react';
import './Services.css';

class Services extends Component {
  render() {
    /*
  "id": 59645,
  "accountId": 1987654323,
  "subscriptionTypeId": 1,
  "subscriptionDescription": "AvaTaxST",
  "endDate": "2999-01-01",
  "createdDate": "2014-12-09T22:00:24.213",
  "createdUserId": 0,
  "modifiedDate": "2015-02-10T13:52:53.627",
  "modifiedUserId": 30609
  */

    if (this.props.data) {
      let services = this.props.data.map((service) => {
        return (
          <tr>
            <td>{service.subscriptionDescription}</td>
            <td className='alignment_center'>{service.subscriptionTypeId}</td>
            <td>{new Date(service.createdDate).toLocaleDateString()}</td>
            <td>
              {service.endDate
                ? `${new Date(
                    // If there is no effective date display January 1st 1900
                    // TODO: remove this when Avatax is returning proper data
                    service.effectiveDate || new Date('01-01-1900')
                  ).toLocaleDateString()} -
                  ${new Date(service.endDate).toLocaleDateString()}`
                : new Date(
                    // If there is no effective date display January 1st 1900
                    // TODO: remove this when Avatax is returning proper data
                    service.effectiveDate || new Date('01-01-1900')
                  ).toLocaleDateString()}
            </td>
          </tr>
        );
      });

      return (
        <table>
          <thead>
            <tr>
              <td className="width_25_percent">Name</td>
              <td className="width_35_percent alignment_center">Service Id</td>
              <td className="width_25_percent">Enabled on</td>
              <td className="width_15_percent">Effective</td>
            </tr>
          </thead>
          <tbody>{services}</tbody>
        </table>
      );
    } else {
      return false;
    }
  }
}

export default Services;
